// Dependencies
require("webstrap/normalize");

// Styles
require("./print.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/webstrap/print/index.js
 ** module id = 16
 ** module chunks = 0 1
 **/